import React from "react";
import {
  AppstoreOutlined,
  BookOutlined,
  CalendarOutlined,
  CheckSquareOutlined,
  DashboardOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  LinkOutlined,
  NodeCollapseOutlined,
  OrderedListOutlined,
  ClockCircleOutlined,
  TableOutlined,
} from "@ant-design/icons";

const KINDS = {
  project: { label: "پروژه", icon: <AppstoreOutlined /> },
  "project-section": { label: "بخش پروژه", icon: <CheckSquareOutlined /> },
  "project-view": { label: "ویو", icon: <FilterOutlined /> },
  task: { label: "تسک", icon: <OrderedListOutlined /> },
};

export const PROJECT_TARGETS = [
  { tab: "Kanban", label: "تخته", icon: <AppstoreOutlined />, tone: "blue" },
  { tab: "Gantt", label: "گانت", icon: <TableOutlined />, tone: "purple" },
  { tab: "TaskList", label: "لیست تسک‌ها", icon: <OrderedListOutlined />, tone: "teal" },
  { tab: "TreeMindMap", label: "درخت", icon: <NodeCollapseOutlined />, tone: "green" },
  { tab: "ArchivedTasks", label: "آرشیو", icon: <BookOutlined />, tone: "orange" },
  { tab: "Calendar", label: "تقویم", icon: <CalendarOutlined />, tone: "blue" },
  {
    tab: "ScheduledTasks",
    label: "تسک‌های دوره‌ای",
    icon: <ClockCircleOutlined />,
    tone: "purple",
  },
  { tab: "Dashboard", label: "پیشخوان", icon: <DashboardOutlined />, tone: "green" },
  {
    tab: "List",
    label: "اطلاعات پروژه",
    icon: <InfoCircleOutlined />,
    tone: "orange",
  },
];

export const resolveSource = (key) =>
  KINDS[key] ?? { label: "میان‌بر", icon: <LinkOutlined /> };

export default KINDS;
